<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import Cookies from "js-cookie";
import User from "@/api/user";
import { mapActions } from "vuex";
export default {
  watch: {
    // 路由变化的时候检查token，没有的话就走微信登录拿token，没有openID就去获取openID
    $route: {
      handler(to) {
        const token = Cookies.get("token") || Cookies.get("token", { domain: "bom.ai" });
        if (token) {
          this.getUserInfo({ Token: token }).catch(() => {
            Cookies.remove("token");
            location.href = "";
          });
          return true;
        }
        const openId = to.query.openid || Cookies.get("openId");
        if (openId && to.query.openid && typeof openId === "string") {
          // 为了安全性考虑，不让URL一直携带openID
          Cookies.set("openId", to.query.openid, { expires: 7 });
          this.$router.replace("/chat");
          return false;
        } else if (openId === undefined) {
          // 没有OpenID就去取ID
          this.getOpenId();
          return null;
        }
        // 到这步一定有openID，接着拿来做微信登录
        this.wechatLogin(openId);
      }
    }
  },
  methods: {
    ...mapActions(["getUserInfo"]),
    // 获取openID
    getOpenId() {
      const getOpenIdUrl = `${process.env.VUE_APP_WECHAT_AUTH}?returnurl=${location.href}`;
      location.href = getOpenIdUrl;
    },
    // 微信登录获取token
    async wechatLogin(openId) {
      const result = await User.wechatLogin(openId);
      if (result.Code === 301) {
        location.href = `/app/login?external_r=${location.href}`;
      } else if (result.Code !== 0) {
        this.$toast("账号存在问题，请向客服咨询！");
      } else {
        this.getUserInfo(result.Data);
        Cookies.set("token", result.Data.Token);
      }
    }
  }
};
</script>
<style>
#app {
  position: relative;
  width: 100vw;
  height: 100vh;
}
</style>
